var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBookmarkOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#757983",
  strokeMiterlimit: 10,
  d: "M6.537 9.37a.63.63 0 0 1 .843 0l3.189 2.972a.205.205 0 0 0 .347-.129V2.186A.194.194 0 0 0 10.715 2H3.202A.194.194 0 0 0 3 2.186v10.027a.206.206 0 0 0 .347.13z"
})));
export default SvgBookmarkOutline;